export const MIN_BOOKING_ADVANCE_HOURS = 16;

const HOUR_MS = 60 * 60 * 1000;

export const getMinBookingDate = (now = new Date()) => new Date(
  now.getTime() + MIN_BOOKING_ADVANCE_HOURS * HOUR_MS,
);

export const isBookableStart = (start, now = new Date()) => (
  new Date(start).getTime() >= getMinBookingDate(now).getTime()
);

const toHour = (time) => Number(time.split(':')[0]);

const getDayHours = (station, date) => {
  switch (date.getDay()) {
    case 0:
      return { open: toHour(station.sun_opened_at), close: toHour(station.sun_closed_at) };
    case 6:
      return { open: toHour(station.sat_opened_at), close: toHour(station.sat_closed_at) };
    default:
      return { open: toHour(station.opened_at), close: toHour(station.closed_at) };
  }
};

// Primer día con horas posibles: salta días cerrados y el día del mínimo si ya cerró.
export const getFirstBookableDay = (station, now = new Date()) => {
  const minDate = getMinBookingDate(now);
  const day = new Date(minDate);
  day.setHours(0, 0, 0, 0);
  for (let i = 0; i < 7; i += 1) {
    const { open, close } = getDayHours(station, day);
    const startHour = i === 0 ? Math.max(open, minDate.getHours()) : open;
    if (startHour < close) return day;
    day.setDate(day.getDate() + 1);
  }
  return day;
};
